import { toDollars } from "../../helpers/currencies";
import { CalculationOutput } from "../../types/Calculation";
import APCalculation from "./APCalculation";

const APCalculationOutput = ({
  calculation,
  currency,
}: {
  calculation: CalculationOutput<number>;
  currency?: boolean;
}) => {
  const renderedResult = currency
    ? toDollars(calculation.result, 2)
    : `${calculation.result}`;

  return (
    <APCalculation
      name={calculation.name}
      value={renderedResult}
      tooltip={calculation.formula}
    />
  );
};

export default APCalculationOutput;
